module.exports = __webpack_public_path__ + "static/site-1784739815621/img/mercadopago-logo.f9ae46a8.webp";